import React, { useState } from "react";
import api from "../api/api";

const ProfileImageUploader = ({ onUploaded }) => {
  const [image, setImage] = useState(null);

  const uploadImage = async () => {
    if (!image) return alert("Selecciona una imagen");

    const formData = new FormData();
    formData.append("image", image);

    try {
      const res = await api.post("/files/upload-profile", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      alert("Imagen subida!");
      onUploaded(res.data.image_url);

    } catch (err) {
      console.error(err);
      alert("Error al subir imagen");
    }
  };

  return (
    <div>
      <input type="file" onChange={e => setImage(e.target.files[0])} />
      <button onClick={uploadImage}>Subir Imagen</button>
    </div>
  );
};

export default ProfileImageUploader;
